import { SERVER_URI } from '../Constant/server';
import { apiGet, apiPost, apiPut } from '../utils/axios';

const getPriceType = SERVER_URI + '/get-price-type';

export default {

  bindPriceType:async function(paylaod)
  {
    return apiPost(getPriceType,paylaod)
    
  }
};